/**
 * 资源更新消息
 * Bai.Zhiming
 * 2019-6-25
 */
angular.module("resourceUpdateMessageModule", []).
controller("resourceUpdateMessageCtrl", ['$scope', 'trsHttpService', 'trsspliceString', '$q', 'messageCenterService', 'modalDialog', 'msgService', '$rootScope',
    function($scope, trsHttpService, trsspliceString, $q, messageCenterService, modalDialog, msgService, $rootScope) {
        initStatus();
        queryTypeCount();
        initData();
        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                tabList: [
                    { name: '全部', value: 'all', message: '', type: 0 },
                    { name: '我的订阅', value: 'trialDraft', message: 0, type: 30 },
                    { name: '共享稿库', value: 'transferDraft', message: '', type: 13 },
                    // { name: '公共素材库', value: 'rejectDraft', message: 0, type:"" },
                ],
                hotLists: {
                    page: {
                        'pn': 1,
                        'PAGESIZE': 20,
                        'PAGECOUNT': 0,
                        'ITEMCOUNT': 0,
                        'startpage': 1,
                    },
                    status: {
                        'jumpToPageNum': 1,
                        'startpage': 1
                    }
                },
                readType: msgService.readType,
            };
            $scope.data = {
                selectedArray: [],
                items: []
            };
        }
        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            $scope.status.selectedTab = $scope.status.tabList[0];
            getCurrentLoginUser().then(() => {
                getData();
            });
        }
        /**
         * [getCurrentLoginUser description] 获取当前登录的用户信息
         * @return {[type]} [description]
         */
        function getCurrentLoginUser() {
            var deferred = $q.defer();
            var userParams = {
                serviceid: "mlf_extuser",
                methodname: "findUserInfo"
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), userParams, "post").
            then(function(data) {
                $scope.data.userInfo = data[0];
                deferred.resolve(data);
            });
            return deferred.promise;
        }
        /**
         * [getAllMessages description] 获取全部消息数据
         * @return {[type]} [description]
         */
        function getAllMessages() {
            let defer = $q.defer();
            let typeids = trsspliceString.spliceString($scope.status.tabList, 'type', ',');
            let params = {
                serviceid: 'message',
                method: 'queryallmsg',
                socketid: $scope.data.userInfo.ID,
                fromtype: 1,
                pagesize: $scope.status.hotLists.page.PAGESIZE,
                pagenumber: $scope.status.hotLists.page.startpage,
                opertype: typeids,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "POST").then(function(data) {
                updataArr(data)
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [getTypeMessages description] 获取不同类型消息数据
         * @param  {[type]} type [description] 类型
         * @return {[type]}      [description]
         */
        function getTypeMessages(type) {
            let defer = $q.defer();
            let params = {
                serviceid: 'message',
                method: 'msgtypelist',
                socketid: $scope.data.userInfo.ID,
                opertype: type,
                pagesize: $scope.status.hotLists.page.PAGESIZE,
                pagenumber: $scope.status.hotLists.page.startpage,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "GET").then(function(data) {
                updataArr(data)
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * updata 接口请求数据后 更新数据
         */
        function updataArr(data) {
            $scope.data.items = data.data.content;
            $scope.status.hotLists.page.pn = data.data.number + 1;
            $scope.status.hotLists.page.PAGESIZE = data.data.size;
            $scope.status.hotLists.page.PAGECOUNT = data.data.totalPages;
            $scope.status.hotLists.page.ITEMCOUNT = data.data.totalElements;
        }
        /**
         * [querytypecount description]根据不同分类查询消息数目
         */
        function queryTypeCount() {
            let defer = $q.defer();
            var typeids = trsspliceString.spliceString($scope.status.tabList, 'type', ',');
            let params = {
                typeids: typeids,
                serviceid: "message",
                method: "querytypecount"
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "GET").then(function(data) {
                let items = data.data;
                $scope.status.tabList.forEach((tab) => {
                    items.forEach((item) => {
                        if (tab.type == item.type) {
                            tab.message = item.count > 99 ? '99+' : item.count;
                        }
                    })
                })
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [tabSwitch description] tab切换
         * @param  {[type]} tab [description] tab
         * @return {[type]}     [description]
         */
        $scope.tabSwitch = function(tab) {
            if ($scope.status.selectedTab.value == tab.value) {
                return;
            }
            $scope.status.selectedTab = tab;
            clearPage();
            getData();
            queryTypeCount();
        }
        /**
         * [returnType description]返回来源
         */
        $scope.returnType = function(type) {
            $scope.status.tabList.forEach((item, index) => {
                if (item.type == type) {
                    return item.name
                }
            })
        }
        /**
         * [pageChanged description]分页请求
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.status.hotLists.status.jumpToPageNum = $scope.status.hotLists.page.pn;
            $scope.status.hotLists.page.startpage = $scope.status.hotLists.page.pn;
            getData();
        };
        $scope.jumpToPage = function() {
            if ($scope.status.hotLists.status.jumpToPageNum > $scope.status.hotLists.page.PAGECOUNT) {
                $scope.status.hotLists.status.jumpToPageNum = $scope.status.hotLists.page.PAGECOUNT;
            }
            if ($scope.status.hotLists.status.jumpToPageNum === "0" || isNaN(Number($scope.status.hotLists.status.jumpToPageNum))) {
                modalDialog.alertType("请输入合法的页码", "", "warning", false);
                return;
            }
            $scope.status.hotLists.page.startpage = $scope.status.hotLists.status.jumpToPageNum;
            getData();
        };
        /**
         * [clearPage description] 还原page信息
         */
        function clearPage() {
            $scope.status.hotLists = {
                page: {
                    'pn': 1,
                    'PAGESIZE': 20,
                    'PAGECOUNT': 0,
                    'ITEMCOUNT': 0,
                    'startpage': 1,
                },
                status: {
                    'jumpToPageNum': 1,
                    'startpage': 1
                }
            }
        }
        /**
         * [getData description] 执行获取数据函数
         */
        function getData() {
            $scope.data.selectedArray = [];
            if ($scope.status.selectedTab.value == 'all') {
                getAllMessages();
            } else {
                getTypeMessages($scope.status.selectedTab.type);
            }
            /*if ($scope.status.selectedTab.value == 'trialDraft' || $scope.status.selectedTab.value == 'rejectDraft') {
                $scope.data.items = [];
                return
            }
            getTypeMessages($scope.status.selectedTab.type);*/
        }
        /**
         * [isChecked description] 判断数据是否选中
         * @param  {[type]}  item [description] 数据
         * @return {Boolean}      [description]
         */
        $scope.isChecked = function(item) {
            return $scope.data.selectedArray.some((_item) => {
                return _item.messageid == item.messageid;
            });
        }
        /**
         * [selectItem description] 选中/取消选中数据
         * @param  {[type]} item [description] 数据
         * @return {[type]}      [description]
         */
        $scope.selectItem = function(item) {
            if ($scope.isChecked(item)) {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            } else {
                $scope.data.selectedArray.push(item);
            }
        }
        /**
         * [selectAll description] 全选/取消全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.items.length > 0 && $scope.data.items.length == $scope.data.selectedArray.length ? [] : [].concat($scope.data.items);
        }
        /**
         *[requestData description] 标记为已读
         * @param  {[type]}  [description] 类型（0:已选数据标记为已读 1:全部标记为已读）
         * @return {[type]}    [description]
         */
        $scope.markAsRead = function(type) {
            var msgsocketrelids = trsspliceString.spliceString($scope.data.selectedArray, 'msgsocketrelid', ',');
            if (type == 0) {
                messageCenterService.messageCenterReadNotices(msgsocketrelids, !!type, $scope.data.userInfo.ID, $scope.status.selectedTab.type).then((data) => {
                    getData();
                    $rootScope.$broadcast('updateMessage', 'update')
                    modalDialog.alertType("设置成功", "", "success", false);
                })
            } else {
                msgsocketrelids = trsspliceString.spliceString($scope.data.items, 'msgsocketrelid', ',');
                messageCenterService.messageCenterReadNotices(msgsocketrelids, !!type, $scope.data.userInfo.ID, $scope.status.selectedTab.type).then((data) => {
                    getData();
                    $rootScope.$broadcast('updateMessage', 'update')
                    modalDialog.alertType("设置成功", "", "success", false);
                })
            }
            $scope.data.selectedArray = [];
        }
        /**
         * [gotoDetail description] 稿件编辑页地址
         * @param  {[item]}  [description] 
         */
        $scope.gotoDetail = function(item) {
            if (item.opertype == 30) {
                msgService.gotoDetail(item).then((data) => {
                    var url = data.data.editurl;
                    getData();
                    $rootScope.$broadcast('updateMessage', 'update')
                    window.open(url);
                });
            }
        }
    }
]);